import React, { useEffect, useState } from 'react';
import { styled, Table, TableBody, TableHead, TableRow, TableCell, Typography, IconButton, Box, Avatar, Menu, MenuItem, Fade, Card, CircularProgress, Button, Grid, TextField } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditStoriesModal from './EditStoriesModal';
import DelStoryModal from './DelStoryModal';
import moment from 'moment-jalaali';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { PREFIX_URL } from '../../../components/Constants';
import axios from './../../../axios/api';
import toast from 'react-hot-toast';
import TablePagination from '@mui/material/TablePagination';

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
    '& .MuiTablePagination-actions .Mui-disabled': {
        color: '#ccc',
    },
    '& .MuiTablePagination-actions': {
        color: 'rgba(0, 0, 0, 0.54)'
    },
}));
const TableStorie = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedId, setSelectedId] = useState(null); // New state to keep track of the selected row's id
    const open = Boolean(anchorEl);
    const [IsopenEditModal, setIsOpenEditModal] = useState(false);
    const [IsopenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const [SearchFilter, setSearchFilter] = useState('');

    const handleClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(id); // Set the selected row's id
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsOpenEditModal(false);
    };

    const handleOpenEditModal = () => {
        setIsOpenEditModal(true);
        setAnchorEl(null);
    };

    const handleOpenDeleteModal = () => {
        setIsOpenDeleteModal(true);
        setAnchorEl(null);
    };

    const handleCloseEditModal = () => {
        setSelectedId(null); // Reset the selected row's id
        setIsOpenEditModal(false);
    };

    const handleCloseDeleteModal = () => {
        setSelectedId(null); // Reset the selected row's id
        setIsOpenDeleteModal(false);
    };
    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    };

    const handleFilter = () => {
        GetData(true);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleFilter();
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
    };

    useEffect(() => {
        GetData();
    }, [page, rowsPerPage]);

    const GetData = async (resetPage = false) => {
        if (resetPage) setPage(1);
        try {
            setIsLoading(true);
            let url = `/admin/ad?is_paginate=true&count_of_page=${rowsPerPage}&type=story`;
            if (SearchFilter) url += `&search=${SearchFilter}`;
            const res = await axios.get(`${url}&page=${resetPage ? 1 : page}`);
            const dataRecived = res.data?.data?.data?.data;
            if (page > 1 && dataRecived?.length == 0) {
                GetData(true);
            } else {
                setData(res.data?.data?.data?.data);
                setTotalResults(res.data?.data?.data?.total);
            }

        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };

    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };

    return (
        <Card variant="outlined" sx={{ margin: 0, width: '100%' }}>

            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item lg={10} md={10} sm={12}>
                    <TextField
                        label="جستجو"
                        placeholder='جستجو براساس عنوان بنر'
                        fullWidth
                        value={SearchFilter}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setSearchFilter(e.target.value)}
                        variant="outlined"
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={12}>
                    <Button
                        onClick={handleFilter}
                        sx={{ padding: '16.5px 14px' }}
                        color="secondary"
                        fullWidth
                        variant="contained"
                        size="large"
                    >
                        <Typography color="white">فیلتر</Typography>
                    </Button>
                </Grid>
            </Grid>

            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {Data.length === 0 ? (
                        <Typography variant="h6" align="center" sx={{ marginTop: 2 }}>
                            هیچ داده ای یافت نشد
                        </Typography>
                    ) : (
                        <>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                #
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                لینک
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                عنوان
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                توضیحات
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                تاریخ اعتبار
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                عملیات
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Data.map((BannerItem) => (
                                        <TableRow key={BannerItem.id}>
                                            <TableCell sx={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                                    <IconButton
                                                        aria-label="linkAdv"
                                                        onClick={() => window.open(checkAndAddPrefix(BannerItem.path), '_blank')}
                                                    >
                                                        <Avatar
                                                            alt={` ${BannerItem.title}`}
                                                            src={checkAndAddPrefix(BannerItem.path)}
                                                            sx={{ width: 50, height: 50 }}
                                                        />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">
                                                    <IconButton
                                                        aria-label="linkAdv"
                                                        onClick={() => window.open(checkAndAddPrefix(BannerItem.link), '_blank')}

                                                    >
                                                        <AttachFileIcon />
                                                    </IconButton>

                                                </Typography>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">{BannerItem.title}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">{(BannerItem.from_date) ? (BannerItem.from_date) : "-"}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">{(BannerItem.to_date) ? (BannerItem.to_date) : "-"}</Typography>
                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">
                                                    <IconButton
                                                        aria-label="more"
                                                        id="fade-button"
                                                        aria-controls={open ? 'long-menu' : undefined}
                                                        aria-expanded={open ? 'true' : undefined}
                                                        aria-haspopup="true"
                                                        onClick={(event) => handleClick(event, BannerItem.id)} // Pass the id here
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    <Menu
                                                        id="fade-menu"
                                                        MenuListProps={{
                                                            'aria-labelledby': 'fade-button',
                                                        }}
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        TransitionComponent={Fade}
                                                    >
                                                        <MenuItem onClick={handleOpenEditModal}>ویرایش</MenuItem>
                                                        <MenuItem onClick={handleOpenDeleteModal}>حذف</MenuItem>
                                                    </Menu>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <StyledTablePagination
                                component="div"
                                count={totalResults}
                                rowsPerPage={rowsPerPage}
                                page={page - 1}  // Adjusting for the 0-based index of TablePagination
                                onPageChange={handleChangePage}
                                rowsPerPageOptions={[]} // Hide rows per page dropdown
                                labelRowsPerPage="" // Hide label
                                showFirstButton
                                showLastButton
                            />
                        </>
                    )}
                </>
            )}
            {IsopenEditModal &&
                <EditStoriesModal
                    open={IsopenEditModal}
                    id={selectedId}
                    refreshData={GetData}
                    handleCloseModal={handleCloseEditModal} />}
            {IsopenDeleteModal &&
                <DelStoryModal
                    id={selectedId}
                    open={IsopenDeleteModal}
                    refreshData={GetData}
                    handleCloseModal={handleCloseDeleteModal}
                />}
        </Card>
    );
};

export default TableStorie;
